<template>
  <div>
    <el-menu
      :default-active="activeIndex"
      :class="{ 'nav-height': isScrolled }"
      background-color="#000000"
      router
    >
      <img
        :src="bgImg.logo_img_url"
        v-if="!isPhone"
        alt=""
        height="96px"
        class="logo"
        @click="goHome()"
      />
      <img
        :src="bgImg.phone_logo_img_url"
        v-else
        alt=""
        height="60px"
        width="auto"
        class="logo"
        @click="goHome()"
      />
      <div class="nav">
        <transition name="slide">
          <div v-if="isShowNav" class="nav-list">
            <el-menu-item index="/">
              <div class="nav-box">
                <div class="t1">HOME</div>
                <div class="t2">首&nbsp;&nbsp;页</div>
              </div>
            </el-menu-item>
            <el-menu-item index="/case" class="case">
              <div class="nav-box">
                <div class="t1">CASE</div>
                <div class="t2">案&nbsp;&nbsp;例</div>
              </div>
            </el-menu-item>
            <el-menu-item index="/dynamics" class="dynamics">
              <div class="nav-box">
                <div class="t1">&nbsp;&nbsp;DYNAMICS&nbsp;&nbsp;</div>
                <div class="t2">公司动态</div>
              </div>
            </el-menu-item>
            <el-menu-item index="/about" class="about">
              <div class="nav-box">
                <div class="t1">ABOUT</div>
                <div class="t2">关于我们</div>
              </div>
            </el-menu-item>
            <el-menu-item index="/contact">
              <div class="nav-box">
                <div class="t1">CONTACT</div>
                <div class="t2">联系我们</div>
              </div>
            </el-menu-item>
          </div>
        </transition>
        <img
          src="../assets/directory@2x.png"
          width="30"
          height="30"
          alt=""
          class="open-icon"
          :class="isShowNav ? 'btn-show' : 'btn-show-roate'"
          @click="toggleClass()"
        />
      </div>
      <div class="phone-nav">
        <img
          src="../assets/directory@2x.png"
          alt=""
          width="20"
          height="20"
          @click="isShowMask()"
        />
      </div>
    </el-menu>
    <div class="phone-mask" @click="isShowMask()" v-if="isShow">
      <ul>
        <li v-for="(item, index) in phoneNavOptions" :key="index">
          <router-link :to="item.path">
            <span :class="item.path === activeIndex ? 'nav-active' : ''">{{
              item.title
            }}</span></router-link
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { mapState } from "vuex";

export default {
  name: "HeaderComponent",
  data() {
    return {
      activeIndex: "/",
      isShow: false,
      phoneNavOptions: [
        {
          title: "HOME",
          path: "/",
        },
        {
          title: "CASE",
          path: "/case",
        },
        {
          title: "DYNAMICS",
          path: "/dynamics",
        },
        {
          title: "ABOUT",
          path: "/about",
        },
        {
          title: "CONTACT",
          path: "/contact",
        },
      ],
      isShowNav: true,
      scrollPosition: 0,
    };
  },
  watch: {
    $route(to, from) {
      this.activeIndex = to.path;
      if (to.name === "caseDetail") {
        this.activeIndex = "/case";
      }
    },
  },
  computed: {
    isScrolled() {
      return this.scrollPosition > 100; // 自定义滚动距离阈值
    },
    ...mapState({
      bgImg: (state) => state.bgImg,
      isPhone: (state) => state.isPhone,
    }),
  },
  methods: {
    isShowMask() {
      this.isShow = !this.isShow;
    },
    toggleClass() {
      this.isShowNav = !this.isShowNav;
    },
    handleScroll() {
      this.scrollPosition = window.scrollY || window.pageYOffset;
    },
    goHome() {
      // 当前路由不为首页路由
      if (this.activeIndex !== "/") {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    const userAgent = window.navigator.userAgent;
    if (!/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
      window.addEventListener("scroll", this.handleScroll);
    } else {
      this.$store.commit("changeIsPhone", true);
    }
    var wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-menu {
  height: 96px;
  background-color: #000000 !important;
  padding: 0 128px 0 0 !important;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  z-index: 99;
  transition: 400ms;
}

.nav-height {
  height: 70px !important;
  transition: 400ms;
}

.logo{
  cursor: pointer;
}

.nav-height .logo {
  height: 70px;
  margin-left: 100px;
}

.nav-height >>> .el-menu-item.is-active::before {
  bottom: -13px;
}
.nav-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}
.t1 {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transition: 400ms;
}

.t2 {
  opacity: 0;
  filter: alpha(opacity=0);
  width: 100%;
  height: 100%;
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: 20px;
  transition: 400ms;
}

.nav-box:hover .t1 {
  top: -15px;
  opacity: 0;
  filter: alpha(opacity=0);
}

.nav-box:hover .t2 {
  top: 0;
  opacity: 1;
  filter: alpha(opacity=100);
}

.nav-list {
  width: 95%;
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  transition: -webkit-transform 300ms, transform 300ms, top 400ms;
}

.open-icon {
  cursor: pointer;
  position: fixed;
  right: 5%;
  top: auto;
  transition: -webkit-transform 300ms, transform 300ms, top 400ms;
}

img {
  display: block;
}

.phone-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background: rgb(192 191 191 / 50%);
  width: 100%;
  z-index: 9999;
}

.phone-mask ul {
  position: absolute;
  padding: 10%;
  background: #000;
  bottom: 0;
  top: 0;
  right: 0;
}

.phone-mask ul li {
  list-style: none;
  margin-bottom: 20px;
}

.phone-mask ul li a {
  text-decoration: none;
  color: #fff;
}

.nav-active {
  color: #fec527;
}
.el-menu::after,
.el-menu::before {
  display: none !important;
}

.nav {
  display: flex;
  align-items: center;
  width: 723px;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
  text-transform: uppercase;
}

.nav * {
  box-sizing: border-box;
}

.btn-show {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

.btn-show-roate {
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.8s;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(50px);
  opacity: 0;
}

.phone-nav {
  display: none;
  color: white;
  padding-right: 10px;
  font-size: 24px;
}

.el-menu-item {
  font-size: 20px !important;
  font-family: PingFang-SC, PingFang-SC !important;
  font-weight: bold;
  overflow: hidden;
  width: 20%;
  text-align: center;
}

.el-menu-item,
.el-submenu__title {
  height: 96px !important;
  line-height: 96px !important;
  color: #808080 !important;
}

.el-menu-item:hover,
.el-menu-item:active {
  background: #000000 !important;
  color: #fec527 !important;
}

.el-menu-item:hover .el-submenu__title {
  color: rgb(235, 232, 232) !important;
}

.el-menu-item.is-active {
  color: #fec527 !important;
  background-color: none !important;
}

.el-menu-item.is-active::before {
  content: "";
  position: absolute;
  bottom: -25px;
  left: 31%;
  width: 20px;
  width: 46px;
  height: 34px;
  background: #fec527;
  border-radius: 50%;
  overflow: hidden;
}

@media screen and (max-width: 1024px) {
  .logo {
    width: 194px;
    height: 60px;
  }
  .nav {
    display: none;
  }

  .phone-nav {
    display: block;
  }

  .el-menu {
    padding: 0 !important;
    height: 60px;
  }
}
@media screen and (min-width: 4096px) {
  .nav {
    margin-right: 85px;
  }
}

.nav >>> .case {
  margin:  0px 14px 0 0px;
}
.nav >>> .dynamics {
  margin:  0px 35px 0 0px;
}
.nav >>> .about {
  margin:  0px 20px 0 0px;
}
</style>